import { render, staticRenderFns } from "./DCOPreviewCheckmark.vue?vue&type=template&id=1431d5e8"
import script from "./DCOPreviewCheckmark.vue?vue&type=script&lang=js"
export * from "./DCOPreviewCheckmark.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports